import React from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';

export const PartnersMainTableRow = ({partner, setSelectedPartner}) => {

    return(
        <div className="card p-2 mt-1">
            <div className="row gx-2 gy-1 align-items-center">
                <div className="col-12 col-md">
                    <div className="row gx-2 gy-1 align-items-center">
                        <div className="col order-first order-md-0">
                            <div className="h5 text-uppercase font-weight-bold ls-1 my-auto">{partner.name}</div>
                        </div>
                        <div className="col col-md-3">
                            <div className="h5 ls-1 my-auto text-truncate">{partner.id}</div>
                        </div>
                        <div className="col text-md-right">
                            <div className="h5 ls-1 my-auto container-press ml-auto text-gray">{partner.numberOfDossiers}</div>
                        </div>
                        {/* <div className="col text-md-right">
                            <div className="h5 ls-1 my-auto container-press ml-auto">Dernier dossier créé</div>
                        </div> */}
                    </div>
                </div>
                <div className="col-12 d-md-none">
                    <hr className="my-0" />
                </div>
                <div className="col-12 col-md-3 col-lg-auto ml-auto">
                    <div className="w-md-min"></div>
                    <div className="flex-row justify-content-md-end">
                        <button type="button" className="btn btn-icon btn-stage-danger shadow-none p-1 rounded-sm mr-auto mr-md-0" data-toggle="modal" data-target="#DeletePartner" onClick={(e) => setSelectedPartner(partner)}>
                            <i className="eva eva-trash-2-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Supprimer l'établissement" data-template='<div class="tooltip tooltip-white-danger" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
                        </button>
                        <Link to={`/backoffice/partners/${partner.id}`} type="button" className="btn btn-icon btn-stage-info shadow-none p-1 rounded-sm ml-2" data-toggle="tooltip" title="Voir le partenaire" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>' onClick={() => { $('[data-toggle="tooltip"]').tooltip("hide");; }} >
                        <i className="eva eva-eye-outline align-middle h4 lh-1 m-auto"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )

}